/* @flow */
import * as React from 'react';

import styles from './styles.module.scss';
import ActionButton from '../ActionButton';

type Props = {
  title?: any,
  footer?: any,
  children?: any,
  onDismiss?: () => any,
};

const Modal = (props: Props): React$Element<any> => {
  const { title, footer, children } = props;
  return (
    <div className={styles.modal} onClick={event => props.onDismiss && props.onDismiss()}>
      <div className={styles.content} onClick={event => event.stopPropagation()}>
        <div className={styles.close}>
          <ActionButton iconName={'close'} onClick={props.onDismiss} />
        </div>
        {title ? (
          <div className={styles.header}>
            <h2 className={styles.title}>{title}</h2>
          </div>
        ) : null}
        <div className={styles.body}>{children}</div>
        {footer ? <div className={styles.footer}>{footer}</div> : null}
      </div>
    </div>
  );
};

export default Modal;
